import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { toKebabCase } from '@helpers';

export type DataTableRow = DataTableRowString | DataTableRowList;

export interface DataTableRowString {
  header: string;
  icon?: string;
  iconTooltip?: string;
  tooltip?: string;
  // link used in combination with routerLink; href for fully-formed urls
  type?: 'href' | 'preformatted' | 'link' | 'string' | 'obfuscated';
  value: string | number;
  url?: any[];
  obfuscated?: boolean;
  callback?: () => void;
}

export interface DataTableRowList {
  header: string;
  icon?: string;
  iconTooltip?: string;
  tooltip?: string;
  type: 'list' | 'tags';
  value: string[];
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-data-table',
  styleUrls: ['./data-table.component.scss'],
  templateUrl: './data-table.component.html'
})
export class DataTableComponent implements OnInit {
  @Input() compact?: boolean;
  @Input() splitRows?: boolean;
  @Input() table: DataTableRow[];

  toKebabCase = toKebabCase;

  constructor() {}

  ngOnInit() {}

  get tableClass(): string {
    if (!this.compact && !this.splitRows) return;

    let classes = [];

    if (this.compact) classes.push('compact');
    if (this.splitRows) {
      let rows = Math.ceil(this.table.length / 2);
      classes.push('rows');
      classes.push(`split-${rows}`);
    }

    return classes.join(' ');
  }
}
